import CapacitorDispatcher from './capacitor'
import CutlassDispatcher from './cutlass'
import CETDispatcher from './customer_experience_tracker'
import RollbarDispatcher from './rollbar'
import RoutersDispatcher from './routers'
import DebugDispatcher from './debug'
import FeaturesDispatcher from './features'
import SlidewareDispatcher from './slideware'
import GTMDispatcher from './gtm'
import RumDispatcher from './rum'

/**
 * Register dispatchers
 */
export default async (app) => {
  // Dispatchers are responsible detecting the lifecycle of
  // the app and reacting accordingly.
  // Listen to the `reset:state` event for when a new state
  // has been created
  FeaturesDispatcher(app)
  await CapacitorDispatcher(app)

  // This registers root level custom dom event listeners
  // so it needs to be high up the chain as other dispatchers
  // may trigger events
  CutlassDispatcher(app)
  RumDispatcher(app)

  RollbarDispatcher(app)
  GTMDispatcher(app)
  SlidewareDispatcher(app)
  CETDispatcher(app)

  if (app.options.router) {
    RoutersDispatcher(app)
  }

  if (app.options.debug) {
    DebugDispatcher(app)
  }
}
